// This service delegates methods to ngx-toastr services and tries to use the same type
// signatures, hence occasional `any`.
/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import {
  ActiveToast,
  IndividualConfig,
  ToastrService as NgxToastrService,
} from 'ngx-toastr';
import { TOASTR_TYPE_CONFIG } from './toastr-service.config';

@Injectable({
  providedIn: 'root',
})
export class ToastrService {
  private toastrService = inject(NgxToastrService);

  success(
    message?: string,
    title?: string,
    override?: Partial<IndividualConfig<any>>,
  ): ActiveToast<any> {
    return this.toastrService.success(
      message,
      title,
      this.applyTypeDefaults('success', override),
    );
  }

  error(
    message?: string,
    title?: string,
    override?: Partial<IndividualConfig<any>>,
  ): ActiveToast<any> {
    return this.toastrService.error(
      message,
      title,
      this.applyTypeDefaults('error', override),
    );
  }

  warning(
    message?: string,
    title?: string,
    override?: Partial<IndividualConfig<any>>,
  ): ActiveToast<any> {
    return this.toastrService.warning(
      message,
      title,
      this.applyTypeDefaults('warning', override),
    );
  }

  info(
    message?: string,
    title?: string,
    override?: Partial<IndividualConfig<any>>,
  ): ActiveToast<any> {
    return this.toastrService.info(
      message,
      title,
      this.applyTypeDefaults('info', override),
    );
  }

  show(
    message?: string,
    title?: string,
    override?: Partial<IndividualConfig<any>>,
    type?: string,
  ): ActiveToast<any> {
    return this.toastrService.show(
      message,
      title,
      this.applyTypeDefaults('show', override),
      type,
    );
  }

  private applyTypeDefaults(
    type: string,
    override?: Partial<IndividualConfig<any>>,
  ): Partial<IndividualConfig<any>> {
    const defaults = TOASTR_TYPE_CONFIG[type] ?? {};
    const options = { ...defaults, ...(override ?? {}) };
    return options;
  }
}
